// extracted by mini-css-extract-plugin
module.exports = {"body":"body_body__QWx2k","container":"body_container__201MC","form":"body_form__2LOix","from1":"body_from1__1en1J","todos":"body_todos__1QgpS","from2":"body_from2__3o4gN"};